<template>
    <div>
        <h1>Testes com Firebase!!!! \o/</h1>
        <ul v-for="(ct, idx) in colecao_teste" :key="idx">
            <li>{{ ct.url }}</li>
        </ul>
    </div>
</template>

<script>
import { db } from "../main";

export default {
  data() {
    return {
      colecao_teste: []
    }
  },
  firestore(){
      return {
          colecao_teste: db.collection('banners') 
      }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Teste.vue